import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { connectRouter, routerMiddleware } from 'connected-react-router';
import { History } from 'history';
import { IAppState, reducers } from './';

export default function configureStore(history: History, initialState?: IAppState) {
  const middleware = [thunk, routerMiddleware(history)];

  const rootReducer = combineReducers({
    ...reducers,
    router: connectRouter(history),
  });

  const enhancers = [];
  const windowIfDefined = typeof window === 'undefined' ? null : (window as any);

  return createStore(rootReducer, initialState, compose(applyMiddleware(...middleware), ...enhancers));
}
